import { render, staticRenderFns } from "./header-top.vue?vue&type=template&id=44cfc4c9&scoped=true&"
import script from "./header-top.vue?vue&type=script&lang=js&"
export * from "./header-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cfc4c9",
  null
  
)

export default component.exports